/* AlpineJS is our main JS utility framework, doc here : https://alpinejs.dev/start-here */
import Alpine from 'alpinejs';
import { CountUp } from './common/CountUp.js'
import { initAlpineJs } from './common/Alpine.js';

import BiggerPicture from "bigger-picture";

import Slider from "./common/Slider";
import Map from "./blocks/Map";
import MapEvent from './blocks/MapEvent.js';
import AjaxEvent from './blocks/AjaxEvent.js';

/**
 * Our document is ready
 */
document.addEventListener('DOMContentLoaded', () => {

  /* Fix mobile display */
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  /* Starts Alpine */
  window.Alpine = Alpine
  Alpine.start();

  //Init map
  const map = document.querySelector('[data-hwc-map]');
  if (map) {
    new Map(map);
  }

  //Init map Members
  const mapEvent = document.querySelector('[data-hwc-map-event]');
  if (mapEvent) {
    new MapEvent(mapEvent);
  }


  const blockEvent = document.querySelector('.hwc-BlockEvent');
  if (blockEvent) {
    new AjaxEvent(blockEvent);
  }

  /* Count Up Triggers */
  const countUpObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        new CountUp(entry.target, parseInt(entry.target.textContent), { separator: '', duration: 3 }).start()
        countUpObserver.unobserve(entry.target);
      }
    });
  }, { root: null, threshold: 0, rootMargin: '-50px' });
  document.querySelectorAll('.js-countup')?.forEach((el) => {
    countUpObserver.observe(el);
  })

  /* Init slider with swiper */
  const sliders = [...document.querySelectorAll('[data-hwc-slider]')];
  if (sliders.length) {
    sliders.forEach((slider) => {
      new Slider(slider);
    })
  }

  /* Init gallery with bigger picture */
  if (typeof BiggerPicture === "function") {

    let bp = BiggerPicture({
      target: document.body
    });

    if (document.querySelectorAll('[data-hwc-lightbox]').length) {
      document.querySelectorAll('[data-hwc-lightbox]').forEach((lightbox) => {
        const links = [...lightbox.querySelectorAll('[data-lightbox-link]')];
        for (let link of links) {
          link.addEventListener("click", (e) => {
            e.preventDefault();
            bp.open({
              items: links,
              el: e.currentTarget,
              intro: 'fadeup',
              scale: 0.9,
            });
          });
        }
      })
    }
  }

  /* Adds class to body if it's domready */
  document.body.classList.add('is-domready');

  /* Replace <a> by <div> in menu */
  document.querySelectorAll('.hwc-MenuInline-link[href="#"]').forEach(link => {
    const div = document.createElement('div');
    div.innerHTML = link.innerHTML;
    div.classList.add('hwc-MenuInline-link');
    link.parentNode.replaceChild(div, link);
  });

})

/**
 * Our window is fully loaded
 */
window.addEventListener('load', () => {
  /* Adds class to body if it's loaded  */
  document.body.classList.add('is-loaded')
})

/**
 * Components instanciation
 */
document.addEventListener('alpine:init', () => {
  initAlpineJs();
})

/**
 * Listen to the resize event
 */
window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});
